import { render, staticRenderFns } from "./PublisherUsers.vue?vue&type=template&id=0dbb9c1c&scoped=true&lang=pug&"
import script from "./PublisherUsers.vue?vue&type=script&lang=js&"
export * from "./PublisherUsers.vue?vue&type=script&lang=js&"
import style0 from "./PublisherUsers.vue?vue&type=style&index=0&id=0dbb9c1c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb9c1c",
  null
  
)

export default component.exports